<template>
  <a
    :href="`https://www.pitchup.com/${
      $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
    }join/`"
    target="_blank"
    class="join-us"
    :class="{ desktop: $isDesktop }"
  >
    <span class="content">
      <translate tag="h3">Site owner?</translate>
      <translate tag="p"
        >Join Pitchup.com and get more bookings, on your terms.</translate
      >
      <translate class="more">Find out more</translate>
    </span>
    <img
      v-if="$isDesktop"
      loading="lazy"
      src="@/assets/homepage/owners-background-icons.png"
      class="icons"
      :alt="$t('Site owner?')"
      width="360"
      height="168"
    />
    <img
      v-else
      loading="lazy"
      src="@/assets/homepage/owners-background-icon.png"
      class="icon"
      :alt="$t('Site owner?')"
      width="130"
      height="130"
    />
  </a>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteOwner extends Vue {}

export default toNative(CampsiteOwner)
</script>

<style scoped>
a {
  position: relative;
  margin: 0;
  text-decoration: none;
  overflow: hidden;
  background-color: #ffefd3;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

a:active {
  filter: brightness(0.75);
}

.icon {
  margin-right: 0.5em;
}

.content {
  padding: 0.2em 0 0.2em 1.4em;
}

h3 {
  color: var(--colour-dark-blue);
  font-size: 1.5em;
  font-weight: bold;
  margin: 0.5em 0;
}

p {
  color: var(--colour-dark-blue);
  line-height: 1.2;
  margin: 0 0 1em 0;
  font-size: var(--body);
}

.more {
  color: white;
  border-radius: 0.5em;
  background: var(--colour-orange);
  padding: 0.5em 1em;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 1em;
}

/* desktop & tablet */
.desktop p {
  font-size: inherit;
}

.desktop .content {
  padding: 0 0 2em 2em;
}
</style>
